import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=6707e8f0&"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js&"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports